import { render, staticRenderFns } from "./fixedBtn.vue?vue&type=template&id=2f1a973c&scoped=true"
import script from "./fixedBtn.vue?vue&type=script&lang=js"
export * from "./fixedBtn.vue?vue&type=script&lang=js"
import style0 from "./fixedBtn.vue?vue&type=style&index=0&id=2f1a973c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1a973c",
  null
  
)

export default component.exports